import { Wrapper } from './Sidebar.styled';
import React, { useCallback, useEffect, useState } from 'react';
import { AreasTree } from 'components/AreasTree/AreasTree';
import { AreaAccordionItem } from 'types/area';
import { parentToChildrenAreasStructure } from 'utilities/areas';
import { ActionsMenu } from '../ActionsMenu/ActionsMenu';
import { Flex, Line } from 'components';
import { useAssessmentContext } from 'contexts/AssessmentContext';
import { handlePrevState } from 'utilities/handlePrevState';

export const Sidebar: React.FC = () => {
  const [areasItems, setAreasItems] = useState<AreaAccordionItem[]>([]);

  const { setFilters, areas } = useAssessmentContext();

  const handleOnClick = useCallback((id: number) => {
    setFilters((prevState) => {
      const actualState = handlePrevState(prevState.area_ids.value, id);
      return {
        ...prevState,
        area_ids: {
          value: actualState
        }
      };
    });
  }, []);

  const handleGetAreas = () => {
    setAreasItems(parentToChildrenAreasStructure(areas));
  };

  useEffect(() => {
    handleGetAreas();
  }, [areas.length]);

  return (
    <Wrapper flexDirection="column">
      <Flex
        flexDirection="column"
        height="70vh"
        overflow="auto"
        style={{ zIndex: '0' }}
      >
        <AreasTree
          onClick={handleOnClick}
          items={areasItems}
          canBeActive={true}
        />
      </Flex>

      <Flex mb={1}>
        <Line />
      </Flex>
      <ActionsMenu />
    </Wrapper>
  );
};
